import Layout from '../../components/Layout';
// import TriperProfilePage from 'modules/Profile/Triper';
// import TriperProfilePage from 'modules/Profile/Triper/profile';
import ExperiencerProfilePage from 'modules/Profile/Experiencer';

import { useStyles } from './styles';

const ProfilePage = () => {
    const classes = useStyles();

    return (
        <Layout contentClassName={classes.content}>
            <ExperiencerProfilePage />
        </Layout>
    );
};

ProfilePage.displayName = 'ProfilePage';

export default ProfilePage;
